import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconOpenPreview(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M12 13.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5Z"
      />
      <path
        fill="currentColor"
        d="M6 12c.94-2.34 3.27-4 6-4s5.06 1.66 6 4c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4Zm3.5 0a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M5 3h14c1 0 2 1 2 2v14c0 1-1 2-2 2H5c-1 0-2-1-2-2V5c0-1 1-2 2-2Zm0 16h14V5H5v14Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
